import axios from "axios";
import i18n from "i18next";
import { useBoundStore } from "../Store/store";
import toast from "react-hot-toast";

function setupInterceptors(instance) {
    instance.interceptors.response.use(
        response => response,
        error => {
            if (error.response && error.response.status === 401) {
                const logout = useBoundStore.getState().logOut;
                logout();
                toast.error(i18n.t('session.expired'));
                window.location.href = "/login";
                // Page is navigating away; suspend the promise chain so callers
                // without a .catch() don't surface an unhandled rejection to Sentry.
                return new Promise(() => {});
            }
            if (error.response && error.response.status === 403) {
                toast.error('Geen toegang tot deze actie.');
            }
            if (!error.response) {
                toast.error(i18n.t('session.connection_error'));
            }

            return Promise.reject(error);
        }
    );
}

export function BaseClient(base = false) {
    const accessToken = useBoundStore.getState().accessToken;

    const client = axios.create({
        baseURL: import.meta.env.VITE_APP_API_URL,
        headers: {
            "Accept": 'application/json',
            "Content-Type": 'application/json',
            "Authorization": `Bearer ${accessToken}`,
            "Accept-Language": i18n.language
        }
    });

    setupInterceptors(client);
    return client;
}

export function BaseUrlClient(base = false) {
    const accessToken = useBoundStore.getState().accessToken;

    const client = axios.create({
        baseURL: import.meta.env.VITE_APP_BASE_API_URL,
        headers: {
            "Accept": 'application/json',
            "Content-Type": 'application/json',
            "Authorization": `Bearer ${accessToken}`,
            "Accept-Language": i18n.language
        }
    });

    setupInterceptors(client);
    return client;
}
